<template>
  <div>
    <div class="map" id="mapScreen2"></div>
    <div class="openWin" v-show="showFlag">
      <div class="iconBox"><span class="title">{{windowTitle}}</span><i class="el-icon-circle-close" id="close"
                                                                        @click="closeWin()"></i></div>
      <div class="box">
        <p><span class="label">安装位置：</span><span class="value">{{detail.location}}</span></p>
        <p><span class="label">设备状态：</span><span class="value">在线</span></p>
        <p><span class="label">设备电量：</span><span class="value">{{detail.dl}}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
  import jk from '@/assets/satistics/img-enviromentdian.png'
  import img1 from '@/assets/map/img4.png'
  import img2 from '@/assets/map/img5.png'
  import img3 from '@/assets/map/img6.png'
  import circleBg from '@/assets/map/cir.png'

  export default {
    props: {
      latitude: {
        type: [Number],
        default: 31.511953
      },
      longitude: {
        type: [Number],
        default: 120.618273
      },
      zoom: {
        type: [Number],
        default: 15
      },
      videoids: {
        default: []
      }
    },
    data() {
      return {
        isMarker: false,
        map: '',
        geometries: [],
        jkLayer: '',
        flag: 1,//燃气烟感
        detail: {},
        windowTitle: '',
        showFlag: false,
      }
    },
    watch: {
      videoids(val) {
        if (val.length > 0) {
          this.geometries.push(
            {
              "id": "1",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.525661, 120.624518),
              "properties": {
                "title": "1"
              },
              data: this.videoids[0]
            },
            {
              "id": "2",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.525665, 120.624546),
              "properties": {
                "title": "2"
              },
              data: this.videoids[1]
            },
            {
              "id": "3",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.5228952, 120.608272),
              "properties": {
                "title": "3"
              },
              data: this.videoids[2]
            },
            {
              "id": "4",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.525667, 120.624502),
              "properties": {
                "title": "4"
              },
              data: this.videoids[3]
            },
            {
              "id": "5",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.522901, 120.608301),
              "properties": {
                "title": "5"
              },
              data: this.videoids[4]
            },
            {
              "id": "6",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.525622, 120.624522),
              "properties": {
                "title": "6"
              },
              data: this.videoids[5]
            },
            {
              "id": "7",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.538642, 120.623143),
              "properties": {
                "title": "7"
              },
              data: this.videoids[6]
            },
            {
              "id": "8",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.538574, 120.623028),
              "properties": {
                "title": "8"
              },
              data: this.videoids[7]
            },
            {
              "id": "9",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.538648, 120.623191),
              "properties": {
                "title": "9"
              },
              data: this.videoids[8]
            },
            {
              "id": "10",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.538585, 120.622988),
              "properties": {
                "title": "10"
              },
              data: this.videoids[9]
            },
          )
          // 监控圈
          this.jkbg = new TMap.MultiMarker({
            map: this.map,
            styles: {
              default: new TMap.MarkerStyle({
                width: 92, // 宽度
                height: 92, // 高度
                anchor: {x: 46, y: 46}, // 锚点位置
                src: circleBg, // 标注点图片url或base64地址
                color: '#fff', // 标注点文本颜色
                size: 22, // 标注点文本文字大小
                offset: {x: 0, y: 16}, // 标注点文本文字基于direction方位的偏移属性
              }),
            },
            geometries: [
              {
                position: new TMap.LatLng(31.525622, 120.624522), // 标注点位置
                content: '4', // 标注点文本
              },
              {
                position: new TMap.LatLng(31.538648, 120.623191), // 标注点位置
                content: '4', // 标注点文本
              },
            ],
          });
          //监控
          this.jkLayer = new TMap.MultiMarker({
            map: this.map,  //指定地图容器
            //样式定义
            styles: {
              //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
              "myStyle4": new TMap.MarkerStyle({
                "width": 32,  // 点标记样式宽度（像素）
                "height": 32, // 点标记样式高度（像素）
                "src": jk,  //图片路径
                //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                // "anchor": {x: 16, y: 32}
              })
            },
            //点标记数据数组
            geometries: this.geometries
          });
          this.jkLayer.on('click', this.markerLayer4);
        }
      }
    },
    mounted() {
      let that = this
      const center = new TMap.LatLng(31.525665, 120.624546);

      this.$nextTick(() => {
        //定义map变量，调用 TMap.Map() 构造函数创建地图
        const map = new TMap.Map('mapScreen2', {
          center: center,//设置地图中心点坐标
          zoom: this.zoom,   //设置地图缩放级别
          pitch: 55,  //设置俯仰角
          rotation: 30,    //设置地图旋转角度
          mapStyleId: 'style1',
        });
        // 隐藏控件
        map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM) // 比例尺控件
        map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE) // 比例尺控件
        map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION) // 旋转控件
        // 去除logo及水印，开发文档中也有去除LOGO的方法，但不能去除左下角信息
        var a = document.querySelector('canvas+div:last-child')
        a.style.display = 'none'

        //创建并初始化MultiMarker
        var markerLayer1 = new TMap.MultiMarker({
          map: map,  //指定地图容器
          //样式定义
          styles: {
            //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
            "myStyle": new TMap.MarkerStyle({
              "width": 32,  // 点标记样式宽度（像素）
              "height": 32, // 点标记样式高度（像素）
              "src": img1,  //图片路径
              //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
              // "anchor": {x: 16, y: 32}
            })
          },
          //点标记数据数组
          geometries: [
            {
              "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              "styleId": 'myStyle',  //指定样式id
              "position": new TMap.LatLng(31.547037, 120.615661),  //点标记坐标位置
              "data": {
                "location": "相城区苏州百木空间家具股份有限公司北(广济北路东)",
                "status": '在线',
                'dl': this.random(90, 100)
              }
            },
            {
              "id": "2",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              "styleId": 'myStyle',  //指定样式id
              "position": new TMap.LatLng(31.5122, 120.617339),  //点标记坐标位置
              "data": {
                "location": "相城区苏州市一泓污水处理有限公司东南(广济北路东)",
                "status": '在线',
                'dl': this.random(90, 100)
              }
            }
          ]
        });
        var markerLayer2 = new TMap.MultiMarker({
          map: map,  //指定地图容器
          //样式定义
          styles: {
            //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
            "myStyle2": new TMap.MarkerStyle({
              "width": 32,  // 点标记样式宽度（像素）
              "height": 32, // 点标记样式高度（像素）
              "src": img2,  //图片路径
              //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
              // "anchor": {x: 16, y: 32}
            })
          },
          //点标记数据数组
          geometries: [
            {
              "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              "styleId": 'myStyle2',  //指定样式id
              "position": new TMap.LatLng(31.530599, 120.625025),
              "data": {
                "location": "相城区牧谷农场南门东南100米",
                "status": '在线',
                'dl': this.random(90, 100)
              }
            },
          ]
        });
        var markerLayer3 = new TMap.MultiMarker({
          map: map,  //指定地图容器
          //样式定义
          styles: {
            //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
            "myStyle3": new TMap.MarkerStyle({
              "width": 32,  // 点标记样式宽度（像素）
              "height": 32, // 点标记样式高度（像素）
              "src": img3,  //图片路径
              //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
              // "anchor": {x: 16, y: 32}
            })
          },
          //点标记数据数组
          geometries: [
            {//第二个点标记
              "id": "1",
              "styleId": 'myStyle3',
              "position": new TMap.LatLng(31.52984, 120.614066),
              "data": {
                "location": "江苏省苏州市相城区姚浜路龙翔驾校旁",
                "status": '在线',
                'dl': this.random(90, 100)
              }
            },
            {//第二个点标记
              "id": "2",
              "styleId": 'myStyle3',
              "position": new TMap.LatLng(31.518687, 120.623113),
              "data": {
                "location": "苏州市好迪医疗器械有限公司(生态路)",
                "status": '在线',
                'dl': this.random(90, 100)
              }
            },
            {//第二个点标记
              "id": "3",
              "styleId": 'myStyle3',
              "position": new TMap.LatLng(31.528076, 120.618273),
              "data": {
                "location": "相城区灵峰公园云峰休闲广场(灵福路西)",
                "status": '在线',
                'dl': this.random(90, 100)
              }
            }

          ]
        });

        this.map = map

        if (this.videoids.length > 0) {
          this.geometries.push(
            {
              "id": "1",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.525661, 120.624518),
              "properties": {
                "title": "1"
              },
              data: this.videoids[0]
            },
            {
              "id": "2",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.525665, 120.624546),
              "properties": {
                "title": "2"
              },
              data: this.videoids[1]
            },
            {
              "id": "3",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.5228952, 120.608272),
              "properties": {
                "title": "3"
              },
              data: this.videoids[2]
            },
            {
              "id": "4",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.525667, 120.624502),
              "properties": {
                "title": "4"
              },
              data: this.videoids[3]
            },
            {
              "id": "5",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.522901, 120.608301),
              "properties": {
                "title": "5"
              },
              data: this.videoids[4]
            },
            {
              "id": "6",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.525622, 120.624522),
              "properties": {
                "title": "6"
              },
              data: this.videoids[5]
            },
            {
              "id": "7",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.538642, 120.623143),
              "properties": {
                "title": "7"
              },
              data: this.videoids[6]
            },
            {
              "id": "8",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.538574, 120.623028),
              "properties": {
                "title": "8"
              },
              data: this.videoids[7]
            },
            {
              "id": "9",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.538648, 120.623191),
              "properties": {
                "title": "9"
              },
              data: this.videoids[8]
            },
            {
              "id": "10",
              "styleId": 'myStyle4',
              "position": new TMap.LatLng(31.538585, 120.622988),
              "properties": {
                "title": "10"
              },
              data: this.videoids[9]
            },
          )
          // 监控圈
          this.jkbg = new TMap.MultiMarker({
            map: this.map,
            styles: {
              default: new TMap.MarkerStyle({
                width: 92, // 宽度
                height: 92, // 高度
                anchor: {x: 46, y: 46}, // 锚点位置
                src: circleBg, // 标注点图片url或base64地址
                color: '#fff', // 标注点文本颜色
                size: 22, // 标注点文本文字大小
                offset: {x: 0, y: 16}, // 标注点文本文字基于direction方位的偏移属性
              }),
            },
            geometries: [
              {
                position: new TMap.LatLng(31.525622, 120.624522), // 标注点位置
                content: '4', // 标注点文本
              },
              {
                position: new TMap.LatLng(31.538648, 120.623191), // 标注点位置
                content: '4', // 标注点文本
              },
            ],
          });

          //监控
          this.jkLayer = new TMap.MultiMarker({
            map: this.map,  //指定地图容器
            //样式定义
            styles: {
              //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
              "myStyle4": new TMap.MarkerStyle({
                "width": 32,  // 点标记样式宽度（像素）
                "height": 32, // 点标记样式高度（像素）
                "src": jk,  //图片路径
                //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                // "anchor": {x: 16, y: 32}
              })
            },
            //点标记数据数组
            geometries: this.geometries
          });
          this.jkLayer.on('click', this.markerLayer4);
        }

        markerLayer1.on("click", this.fun1)
        markerLayer2.on("click", this.fun2)
        markerLayer3.on("click", this.fun3)
        this.map.on("zoom", this.fun4)
      })
    },
    beforeDestroy() {
      // this.jkLayer.setGeometries([])
      // this.jkbg.setGeometries([])
      this.jkbg.setMap(null)
      this.jkLayer.setMap(null)
    },
    methods: {
      // 设置中心点
      setCenter(lat, lng) {
        let that = this
        console.log("更新中心点到:" + lat + "," + lng)
        const center = new TMap.LatLng(lat, lng);
        that.map.setCenter(center);
      },
      markerLayer4(res) {
        this.geometries.map((item => {
          if (item.id == res.geometry.id) {
            this.$emit('handleView', item.data)
          }
        }))
      },
      fun1(res) {
        this.windowTitle = '水质监测设备'
        this.showFlag = true
        this.detail = res.geometry.data
      },
      fun2(res) {
        this.windowTitle = '农业环境监测设备'
        this.showFlag = true
        this.detail = res.geometry.data
      },
      fun3(res) {
        this.windowTitle = '环境传感器'
        this.showFlag = true
        this.detail = res.geometry.data
      },
      random(lower, upper) {
        // 包括下线数字（lower）也包括上限数字（upper）
        return Math.floor(Math.random() * (upper - lower + 1)) + lower;
      },
      closeWin() {
        this.showFlag = false
        this.flag = 1
      },
      fun4(res) {
        var zoomCurrent = this.map.getZoom()
        if (zoomCurrent >= 16) {
          this.jkbg.setMap(null)
        } else {
          this.jkbg.setMap(null)
          this.jkLayer.setMap(null)
          // 监控圈
          this.jkbg = new TMap.MultiMarker({
            map: this.map,
            styles: {
              default: new TMap.MarkerStyle({
                width: 92, // 宽度
                height: 92, // 高度
                anchor: {x: 46, y: 46}, // 锚点位置
                src: circleBg, // 标注点图片url或base64地址
                color: '#fff', // 标注点文本颜色
                size: 22, // 标注点文本文字大小
                offset: {x: 0, y: 16}, // 标注点文本文字基于direction方位的偏移属性
              }),
            },
            geometries: [
              {
                position: new TMap.LatLng(31.525622, 120.624522), // 标注点位置
                content: '4', // 标注点文本
              },
              {
                position: new TMap.LatLng(31.538648, 120.623191), // 标注点位置
                content: '4', // 标注点文本
              },
            ],
          });
          //监控
          this.jkLayer = new TMap.MultiMarker({
            map: this.map,  //指定地图容器
            //样式定义
            styles: {
              //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
              "myStyle4": new TMap.MarkerStyle({
                "width": 32,  // 点标记样式宽度（像素）
                "height": 32, // 点标记样式高度（像素）
                "src": jk,  //图片路径
                //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                // "anchor": {x: 16, y: 32}
              })
            },
            //点标记数据数组
            geometries: this.geometries
          });
          this.jkLayer.on('click', this.markerLayer4);
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .map {
    height: 100%;
    position: relative;
    width: 100%;
    z-index: 1;
  }

  .openWin {
    padding: 10px 15px;
    position: absolute;
    top: 5%;
    right: 5%;
    z-index: 1000;
    color: #fff;
    background-color: rgba(3, 28, 82, 0.7);
    border-radius: 4px;
    font-size: 16px;
    border: 1px solid #0A205C;
    min-width: 250px;

    .iconBox {
      width: 100%;
      color: #ffffff;
      display: flex;
      align-items: center;

      #close {
        text-align: right;
        font-size: 20px;
        flex-grow: 1;
      }

      .title {
        text-align: left;
        font-size: 18px;
      }
    }

    .box {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    .label {
      display: inline-block;
      line-height: 28px;
    }
  }
</style>
